import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { MediaAudioContentTypeEnum, MediaTypeEnum } from 'constants-media';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    default: MediaTypeEnum.Audio,
    validators: [
      {
        name: 'In',
        value: [MediaTypeEnum.Audio],
      },
    ],
  },
  contentType: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(MediaAudioContentTypeEnum),
      },
    ],
  },
};

export class AudioType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  superUserOnly = true;

  name = 'Audio';

  friendlyName = 'Audio';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];
  properties = properties;

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const definition = new AudioType();

Types.addBaseType(definition);

export { definition as AudioDefinition };
